import { trackEvent } from '@/core/analytics'
import { planTypeFromCode } from '@/core/analytics/plan-type'
import type { ComposeUiUnsupportedReason } from '@/shared/lib/compose-ui-support'

/** A shared Compose feature, as analytics names it. */
export type ComposeFeature = 'collection'

export type UnsupportedBrowserReport = {
  feature: ComposeFeature
  reason: ComposeUiUnsupportedReason
  planCode: string | undefined
}

const EVENT = 'unsupportedBrowser'
const SCREEN = { screenName: 'unsupportedBrowser', screenType: 'page' }

const reportedTabs = new Set<ComposeFeature>()

function properties(
  { feature, reason, planCode }: UnsupportedBrowserReport,
  surface: 'tab' | 'page',
) {
  return {
    feature,
    reason,
    surface,
    planType: planCode ? planTypeFromCode(planCode) : null,
  }
}

/**
 * An eligible person is on a browser that cannot run the feature, counted at the tab gate. Once per
 * page load: the gate is asked on every render. The `tab` value predates the tab being kept.
 */
export function trackUnsupportedBrowserTab(report: UnsupportedBrowserReport) {
  if (reportedTabs.has(report.feature)) return
  reportedTabs.add(report.feature)
  trackEvent(EVENT, properties(report, 'tab'))
}

/** The unsupported screen was shown in place of the feature. */
export function trackUnsupportedBrowserPage(report: UnsupportedBrowserReport) {
  trackEvent(EVENT, properties(report, 'page'))
  trackEvent('screenView', { ...SCREEN, feature: report.feature })
}

/** Tests only: a real page load starts with nothing reported. */
export function resetUnsupportedBrowserReportsForTests() {
  reportedTabs.clear()
}
